import React, { Component } from "react"
import * as PropTypes from 'prop-types'
import clsx from 'clsx'

class CKContent extends Component {
    render() {
        return (
            <div className={clsx("ck-content", this.props.className)} dangerouslySetInnerHTML={{
                __html: this.props.data ?? ''
            }} />
        )
    }
}

CKContent.propTypes = {
    data: PropTypes.string,
    className: PropTypes.string,
}

export default CKContent
